import React from 'react';
import Hero from '../components/Hero';
import RSVP from '../components/RSVP';

const Home = ({ isNavbarVisible }) => {
  return (
    <>
      <Hero isNavbarVisible={isNavbarVisible} />
      <RSVP />
    </>
  );
};

export default Home;
